'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const userHighContrastPreference = typeof window !== 'undefined' && window.matchMedia('(prefers-contrast: more)').matches;
const ContrastModeContext = /*#__PURE__*/ React.createContext(undefined);
const ContrastModeSetter = /*#__PURE__*/ React.createContext(undefined);
export function ContrastModeProvider({ children }) {
    const [contrastMode, setContrastMode] = React.useState(userHighContrastPreference || false);
    const contrastModeSetter = React.useCallback((value)=>{
        setContrastMode(value);
    }, []);
    return /*#__PURE__*/ _jsx(ContrastModeContext, {
        value: contrastMode,
        children: /*#__PURE__*/ _jsx(ContrastModeSetter, {
            value: contrastModeSetter,
            children: children
        })
    });
}
export default function useContrastMode() {
    const context = React.use(ContrastModeContext);
    if (context === undefined) {
        throw new Error('useContrastMode must be used within a ContrastModeProvider');
    }
    return context;
}
export function useSetContrastMode() {
    const context = React.use(ContrastModeSetter);
    if (context === undefined) {
        throw new Error('useSetContrastMode must be used within a ContrastModeProvider');
    }
    return context;
}
export function useContrastModeAtom() {
    return [
        useContrastMode(),
        useSetContrastMode()
    ];
}

//# sourceMappingURL=contrastModeAtom.js.map